import React from 'react';

import { LinkProps } from 'Elements/Link';

import { List, ListItem, StyledLink } from './MediaHub.styled';

export interface Props {
    links: LinkProps[];
    backgroundColor?: string;
}

const MediaHub: React.FC<Props> = props => {
    const { links, backgroundColor } = props;

    return links.length > 0 ? (
        <List $backgroundColor={backgroundColor}>
            {links.map((link, index) => (
                <ListItem key={index}>
                    <StyledLink {...link} />
                </ListItem>
            ))}
        </List>
    ) : null;
};

export default MediaHub;
